<template>
  <v-sparkline
    class="sparkline-updates-trend"
    lineCap="round"
    :type="'trend'"
    :value="getSparklineData"
    :smooth="10"
    :label-size="15"
    :color="'success'"
    :gradient="getGradient"
    :gradient-direction="'bottom'"
    :ref="getId"
  >
  </v-sparkline>
</template>

<script>

    // risk
    // const gradientColors = ['green', 'yellowgreen', 'darkorange', 'red'];
    // engagement
    const gradientColors = ['green', 'darkorange', 'red'].reverse();
    export default {
        name: "trendChangesNewAlgorithm",
        props: ['profile'],
        computed: {
          getSparklineData() {
            let data = this.profile.edges.engagement.history.reverse().map(e => 2 - e.total.value);
            // DIRTY!!! to adjust svg viewbox
            data.unshift(...[0, 2, 2]);
            return data;
          },
          getId(){
            return this.profile._id;
          },
          getGradient() {
            return gradientColors;
            // let gradientArr = [];
            // this.profile.edges.market.engagementWeightsLabels.map(e => e.value)
            //   .sort((c, p) => c - p)
            //   .filter((e, index, self) => self.indexOf(e) === index)
            //   .forEach(e => gradientArr.push(gradientColors[e]))
            // ;
            // gradientArr.push(gradientColors[3]);
            // return gradientArr;
          }
        },
        mounted() {
          // DIRTY!!!
          const v = this.$refs[this.profile._id].$el.viewBox.baseVal.width / (this.$refs[this.profile._id].value.length - 3 + 1.5) * 3;
          this.$refs[this.profile._id].$el.viewBox.baseVal.x = v;
          this.$refs[this.profile._id].$el.viewBox.baseVal.width -= v;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/trendChangesNewAlgorithm.vue